var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataBO.legalSect)?_c('div',{class:['legalMentions', _vm.compClass]},[_c('p',{staticClass:"h2",domProps:{"innerHTML":_vm._s(_vm.dataBO.legalSect.legalTitle)}}),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.dataBO.legalSect.legalContent)}},[_vm._v("Lorem ipsum dolor sit amet.")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }